import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';

const ClientLeadCreate = (props) => {
  return (
    <Stack>

    </Stack>
  );
};
ClientLeadCreate.propTypes = {
  oldData: PropTypes.object.isRequired,
  newData: PropTypes.object.isRequired,
};

export default React.memo(ClientLeadCreate);
